import { useCallback, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { ApiErrors } from '../../enums';
import { usePostPaymentScheduleBilletMutation } from '../../services/billetApi';
import { mapBilletErrorToMessage } from '../../utils/errorMessages';
export function usePostPayBilletScheduled() {
    const [triggerSchedule] = usePostPaymentScheduleBilletMutation();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [errorNoFundsAvailableScheduled, setErrorNoFundsAvailableScheduled] = useState(false);
    const [errorMessagePostPaymentScheduled, setErrorMessagePostPaymentScheduled] = useState();
    const [billetInfoScheduled, setBilletInfoScheduled] = useState();
    const [errorScheduleAlreadyExists, setErrorScheduleAlreadyExists] = useState(false);
    const handlePostBilletScheduledError = useCallback((error) => {
        const errorMessage = mapBilletErrorToMessage(error, t);
        if (error.result?.errorCode === ApiErrors.NO_FUNDS_AVAILABLE ||
            error.result?.errorCode === ApiErrors.ERROR_NO_FUNDS_AVAILABLE) {
            setErrorNoFundsAvailableScheduled(true);
            return;
        }
        if (error.result?.errorCode === ApiErrors.SCHEDULE_ALREADY_EXISTS) {
            setErrorScheduleAlreadyExists(true);
            return;
        }
        setErrorMessagePostPaymentScheduled(errorMessage);
    }, [t]);
    const handleBilletSuccess = useCallback((data) => {
        setErrorMessagePostPaymentScheduled(undefined);
        if (data?.result) {
            setBilletInfoScheduled(data.result);
        }
        else {
            setErrorMessagePostPaymentScheduled(t('invalid-code-billet-not-found-error'));
        }
    }, [t]);
    async function postPaymentScheduleBillet(value, isOperatorRequestPayment) {
        setLoading(true);
        setErrorMessagePostPaymentScheduled(undefined);
        setBilletInfoScheduled(undefined);
        if (!value) {
            setLoading(false);
            return;
        }
        try {
            const { data, error } = await triggerSchedule({
                body: value,
                isOperatorRequestPayment,
            });
            if (error) {
                handlePostBilletScheduledError(error);
                return;
            }
            if (data) {
                handleBilletSuccess(data);
            }
        }
        catch (err) {
            handlePostBilletScheduledError(err);
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        billetInfoScheduled,
        errorMessagePostPaymentScheduled,
        errorNoFundsAvailableScheduled,
        errorScheduleAlreadyExists,
        postPaymentScheduleBillet,
        setErrorNoFundsAvailableScheduled,
        setErrorMessagePostPaymentScheduled,
        setErrorScheduleAlreadyExists,
    };
}
